import React, { useState, useEffect } from 'react';
import './SplashScreen.css';
import trade from '../trademark.png';

const SplashScreen = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Get all image elements from the DOM, excluding background images
    const images = document.querySelectorAll('img');
    let loadedImages = 0;
    const totalImages = images.length;

    if (totalImages === 0) {
      // If no images, complete immediately
      setTimeout(() => {
        setFadeOut(true);
        setTimeout(() => {
          setIsVisible(false);
          onComplete();
        }, 500);
      }, 2000);
      return;
    }

    const handleImageLoad = () => {
      loadedImages++;
      const newProgress = (loadedImages / totalImages) * 100;
      setProgress(newProgress);

      if (loadedImages === totalImages) {
        // All images loaded, start fade out
        setTimeout(() => {
          setFadeOut(true);
          setTimeout(() => {
            setIsVisible(false);
            onComplete();
          }, 500);
        }, 500);
      }
    };

    // Check if images are already loaded
    images.forEach(img => {
      if (img.complete) {
        handleImageLoad();
      } else {
        img.addEventListener('load', handleImageLoad);
        img.addEventListener('error', handleImageLoad); // Handle errors gracefully
      }
    });

    // Fallback timeout in case some images don't load
    const fallbackTimeout = setTimeout(() => {
      if (isVisible && !fadeOut) {
        setFadeOut(true);
        setTimeout(() => {
          setIsVisible(false);
          onComplete();
        }, 500);
      }
    }, 8000);

    return () => {
      clearTimeout(fallbackTimeout);
      images.forEach(img => {
        img.removeEventListener('load', handleImageLoad);
        img.removeEventListener('error', handleImageLoad);
      });
    };
  }, [isVisible, fadeOut, onComplete]);

  if (!isVisible) return null;

  return (
    <div className={`splash-screen ${fadeOut ? 'fade-out' : ''}`}>
      <div className="splash-content">
        <div className="logo-container">
          <img src={trade} alt="CodeGenexis Logo" className="splash-logo" />
        </div>
        <div className="company-name">CodeGenexis</div>
        <div className="tagline">Your Vision Into Reality</div>
        
        <div className="loading-bar">
          <div className="loading-progress" style={{ width: `${progress}%` }}></div>
        </div>
        
        <div className="loading-text">
          Loading... {Math.round(progress)}%
        </div>
      </div>
      
      <div className="splash-background">
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen; 